import { Grid, Modal, Paper, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';

import Processing from 'components/animations/Processing';
import HomeAnimations from 'components/animations/HomeAnimations';

import Header from 'components/Header';
import TeamCard from 'components/TeamCard';
import UserCard from 'components/UserCard';
import { ctx, IStore } from 'store';
import msLogo from 'assets/images/ms-login.svg';

import { useStyles } from './styles';

const SLACK_CLIENT_ID = process.env.REACT_APP_SLACK_CLIENT_ID;
const SLACK_LOGIN_REDIRECT_URI = process.env.REACT_APP_SLACK_LOGIN_REDIRECT_URI;
const MS_CLIENT_ID = process.env.REACT_APP_MS_CLIENT_ID;
const MS_LOGIN_REDIRECT_URI = process.env.REACT_APP_MS_LOGIN_REDIRECT_URI;

const Home: React.FC = () => {
  const classes = useStyles();
  const [processing, setProcessing] = useState(false);
  const {
    teams: { teams },
    tenants: { tenants },
    auth: { user },
  } = useContext(ctx.store);
  const actions = useContext(ctx.actions);

  useEffect(() => {
    document.title = 'Sensla | Analysis for a Great Environment';
    const fetchUser = async () => {
      const { auth } = await ((actions.auth.me() as unknown) as Promise<IStore>);
      if (auth.user.confirmed) {
        await ((actions.misc.setLoading(true) as unknown) as Promise<IStore>);
        await ((actions.tenants.getTenants() as unknown) as Promise<IStore>);
        await ((actions.teams.getTeams() as unknown) as Promise<IStore>);
        await ((actions.members.getMembers() as unknown) as Promise<IStore>);
        await ((actions.members.getMsMembers() as unknown) as Promise<IStore>);
      }
    };

    if (!user || !user.confirmed) {
      fetchUser();
    } else {
      actions.tenants.getTenants();
      actions.teams.getTeams();
      actions.members.getMembers();
      actions.members.getMsMembers();
    }
  }, []);

  useEffect(() => {
    const existProcessing = [...teams, ...tenants].filter(
      (item: any) => !item.active && item.processing
    );
    setProcessing(existProcessing.length > 0);
  }, [tenants, teams]);

  const loadedTeams = [...teams, ...tenants];

  return (
    <Grid className={classes.homeView}>
      <Header />
      <Grid className={classes.homeContent}>
        <Grid className={classes.currentView}>
          <Typography component="h2" className={classes.title}>
            {`Workspaces associated with ${user.email}`}
          </Typography>
          <Grid container spacing={2} style={{ justifyContent: 'center' }}>
            <Grid item sm={12} md={5}>
              <Paper className={classes.menuBox}>
                <Grid style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography component="h2" className={classes.menuBoxTitle}>
                    My Personal Analytics
                  </Typography>
                  <Grid style={{ display: 'flex', flexDirection: 'row' }}>
                    <Grid item className={classes.menuBoxItem}>
                      <HomeAnimations speed={0.2} type="my" />
                    </Grid>
                    <Grid className={classes.menuBoxItemRight}>
                      {!!loadedTeams.length &&
                        [
                          ...(user as any).msMembers,
                          ...(user as any).members,
                        ].map((user: any, index: number) => (
                          <UserCard key={index} user={user} teams={loadedTeams} />
                        ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            <Grid item sm={12} md={5}>
              <Paper className={classes.menuBoxCenter}>
                <Grid style={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography component="h2" className={classes.menuBoxTitle}>
                    Workspaces for Managers
                  </Typography>
                  <Grid style={{ display: 'flex', flexDirection: 'row' }}>
                    <Grid item className={classes.menuBoxItem}>
                      <HomeAnimations speed={0.6} type="teams" />
                    </Grid>
                    <Grid className={classes.menuBoxItemRight}>
                      {/* <Typography component="h2" className={classes.menuBoxTitleRight}>
                    Active Workspaces
                  </Typography> */}
                      {loadedTeams.map((team: any, index: number) => (
                        <TeamCard key={index} data={team} user={user} />
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            {/* <Grid item sm={12} md={10} lg={4}>
              <Paper className={classes.menuBox}>
                <Grid item className={classes.menuBoxItem}>
                  <Typography component="h2" className={classes.menuBoxTitle}>
                    Featured Resources
                  </Typography>
                  <HomeAnimations speed={1} type="resources" />
                </Grid>
                <Grid className={classes.menuBoxItemRight}>
                  {featuredResources.slice(0, 4).map((resource: any, index: number) => (
                    <MiniResourceCard key={index} resource={resource} />
                  ))}
                </Grid>
              </Paper>
            </Grid> */}
          </Grid>
        </Grid>
        <Grid className={classes.newView}>
          <Typography component="h2" className={classes.title}>
            Do you want to enter another account that you don't see here or do you want to add
            another workspace?
          </Typography>
          <Typography component="h3" className={classes.warning}>
            Click on the button below and log in with the account you wish to see in Sensla.
          </Typography>
          <Grid style={{ flexDirection: 'row' }}>
            <a
              className={classes.slackButton}
              href={`https://slack.com/oauth/v2/authorize?redirect_uri=${SLACK_LOGIN_REDIRECT_URI}&user_scope=identity.basic,identity.email,identity.team,identity.avatar&client_id=${SLACK_CLIENT_ID}`}
            >
              <img
                alt="Sign in with Slack"
                height="40"
                width="172"
                src="https://platform.slack-edge.com/img/sign_in_with_slack.png"
                srcSet="https://platform.slack-edge.com/img/sign_in_with_slack.png 1x, https://platform.slack-edge.com/img/sign_in_with_slack@2x.png 2x"
              />
            </a>
            <a
              className={classes.slackButton}
              href={`https://login.microsoftonline.com/common/oauth2/v2.0/authorize?
            client_id=${MS_CLIENT_ID}
            &response_type=code
            &redirect_uri=${MS_LOGIN_REDIRECT_URI}
            &response_mode=query
            &scope=https%3A%2F%2Fgraph.microsoft.com%2Fuser.read%20
            https%3A%2F%2Fgraph.microsoft.com%2Fprofile%20`}
            >
              <img alt="Sign in with Microsoft" width="200" src={msLogo} />
            </a>
          </Grid>
        </Grid>
      </Grid>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={processing}
      >
        <div className={classes.paper}>
          <Typography className={classes.modalText}>
            We are preparing your dashboard. This could take a couple of minutes, please wait!
          </Typography>
          <Processing />
          <Typography className={classes.modalTextContact}>
            If you have any questions, please write us to support@sensla.io
          </Typography>
        </div>
      </Modal>
    </Grid>
  );
};

export { Home };
